import { BrowserRouter, Route, Routes } from "react-router-dom";
import TextExtractor from "@/pages/TextExtractor";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<TextExtractor />} path="/" />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
